import { render } from "./EditCategoryView.vue?vue&type=template&id=521d4d8a"
import script from "./EditCategoryView.vue?vue&type=script&lang=js"
export * from "./EditCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__